
import useLocalStorage from "/src/hooks/useLocalStorage";
import authService from "../services/auth";
import storage from "/src/utils/storage";
//import { toastSuccess, toastError } from "/src/layouts/toast/action/toastAction";

async function signIn(dispatch, data) {

    //const [token, setToken] = useLocalStorage("token", null);
    dispatch({type : 'loginPending'});

    let [response, error] = await authService.signIn(data);

    // if(error !== null) {
    //     //toastError("Login Failed");
    //     console.error(error);
    //     dispatch({type : 'loginFailed', payload : null});
    //     return false;
    // }

    if (error !== null) {
            return {
                error: true,
                status: error.message === "Renew Password" ? 403 : 0,
                message: error.message
            };

    }

    const { token, user, company, permissions, refresh_token } = response;
    
    dispatch({type : 'loginSuccess', payload : {refresh_token, token, user}});
    
    storage('local').set('token', token);
    storage('local').set('refresh_token', refresh_token);
    storage('local').set('user', user);
    storage('session').set('company', company);
    storage('session').set('permissions', permissions);

    return response;
}

function signOut(dispatch) {

    //const [token, setToken] = useLocalStorage("token", null);
    //const dispatch = useAuthDispatchContext();

    sessionStorage.removeItem('user');
    localStorage.removeItem('token');
    dispatch({type : 'logout'});
}

export default { signIn, signOut }